import { render, staticRenderFns } from "./opened-resolved-filter.vue?vue&type=template&id=2ad9acb8&"
import script from "./opened-resolved-filter.vue?vue&type=script&lang=js&"
export * from "./opened-resolved-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports